"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getResizedImageUrl = exports.MODES = void 0;
var tslib_1 = require("tslib");
var endpoints_1 = require("@wix/wix-vod-constants/dist/common/endpoints");
var resize_youtube_thumbnail_1 = (0, tslib_1.__importStar)(require("./resize-youtube-thumbnails/resize-youtube-thumbnail"));
var hosts_1 = require("@wix/wix-vod-constants/dist/env/hosts");
var supportsWebP_1 = (0, tslib_1.__importDefault)(require("./supportsWebP"));
var JPEG_PARAMS = {
    q: 85,
    usm: '0.66_1.00_0.01',
};
var MODES;
(function (MODES) {
    MODES["fit"] = "fit";
    MODES["fill"] = "fill";
})(MODES = exports.MODES || (exports.MODES = {}));
var getFullThumbnailUrl = function (imageHost, relativeUrl) {
    return "".concat(imageHost, "/").concat(relativeUrl);
};
var isJPEG = function (extension) { return /^jpe?g$/i.test(extension); };
var isGIF = function (extension) { return /^gif$/i.test(extension); };
function forceSSL(url) {
    return url.replace(/^http:\/\//, 'https://');
}
var modifyUrlWithParams = function (url, mode, params) {
    return (0, tslib_1.__spreadArray)((0, tslib_1.__spreadArray)([], (0, tslib_1.__read)(url.split('/')), false), [
        'v1',
        mode,
        "w_".concat(params.w, ",h_").concat(params.h),
        supportsWebP_1.default ? 'file.webp' : 'file.jpeg',
    ], false).join('/');
};
var _getResizedImageUrl = function (_a) {
    var url = _a.url, width = _a.width, _b = _a.height, height = _b === void 0 ? width : _b, _c = _a.params, params = _c === void 0 ? {} : _c, mode = _a.mode, _d = _a.imageHost, imageHost = _d === void 0 ? hosts_1.PRODUCTION_HOSTS.image : _d;
    if (!url) {
        return '';
    }
    width = Math.round(width);
    height = Math.round(height);
    mode = mode === MODES.fit ? MODES.fit : MODES.fill;
    params = (0, tslib_1.__assign)((0, tslib_1.__assign)({}, params), { w: width, h: height });
    if (url.startsWith(endpoints_1.FILES_MEDIA_PLATFORM_HOST)) {
        // TODO: Talk to BE why it saves file url host for images
        url = url.replace(endpoints_1.FILES_MEDIA_PLATFORM_HOST, endpoints_1.IMAGES_MEDIA_PLATFORM_HOST);
    }
    if (url.startsWith(hosts_1.PRODUCTION_HOSTS.image)) {
        if (params.w && params.h) {
            return modifyUrlWithParams((0, tslib_1.__spreadArray)([], (0, tslib_1.__read)(url.split('/').slice(0, -1)), false).join('/'), mode, params);
        }
        return url;
    }
    var fullFilename = url.split('/').pop();
    var imagePath = url.replace(fullFilename, '');
    var filenameSplitted = fullFilename.split('.');
    var filename = filenameSplitted.slice(0, -1).join('.');
    var ext = filenameSplitted[filenameSplitted.length - 1];
    if (isGIF(ext)) {
        return url;
    }
    if (url.includes(endpoints_1.MEDIA_PLATFORM_DOMAIN)) {
        if (params.w && params.h) {
            return modifyUrlWithParams(url, mode, params);
        }
        return url;
    }
    if (resize_youtube_thumbnail_1.YOUTUBE_THUMBNAIL_PATTERN.test(url)) {
        return (0, resize_youtube_thumbnail_1.default)(url, width, height);
    }
    if (/vimeocdn/.test(url)) {
        return url.replace(/(_\d+(x\d+)?)?\.jpg/, "_".concat(width, "x").concat(height, ".jpg"));
    }
    if (/^(https?:)?\/\//.test(url)) {
        return url;
    }
    if (/^media\//.test(url)) {
        // this workaround was done in order to get direct link to media file from non-wix-sdk environment
        return "https://static.wixstatic.com/media/".concat(url.replace(/^media\//, ''));
    }
    if (isJPEG(ext)) {
        // NOTE: currently we are not supporting WEBP for file.jpeg because of backend bug,
        // for more information contact Slava G.
        if (fullFilename !== 'file.jpeg' && supportsWebP_1.default) {
            ext = 'webp';
        }
        params = (0, tslib_1.__assign)((0, tslib_1.__assign)({}, params), JPEG_PARAMS);
    }
    var keys = Object.keys(params);
    var imageParamsPath = keys
        .map(function (key) {
        var value = params[key];
        return "".concat(key, "_").concat(value);
    })
        .join(',');
    var fullImagePath = "".concat(imagePath, "v1/").concat(mode, "/").concat(imageParamsPath, "/").concat(filename, ".").concat(ext);
    return getFullThumbnailUrl(imageHost, fullImagePath);
};
function getResizedImageUrl(args) {
    var fullUrl = _getResizedImageUrl(args);
    return forceSSL(fullUrl);
}
exports.getResizedImageUrl = getResizedImageUrl;
//# sourceMappingURL=get-resized-image-url.js.map